import { createIcon } from './createIcon'

export const ExpandIcon = createIcon({
  displayName: 'ExpandIcon',
  viewBox: '1.2 1.25 14.9 14.9',
  path: [
    <path
      d="M10 7.35123L15.0122 2.33901"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M15.0121 7.01709V2.33902H10.334"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M7.35107 10L2.33886 15.0122"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M2.33902 10.3342L2.33902 15.0122L7.01709 15.0122"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
